import { SummaryWrap, SummaryItem } from 'app/common/templates-next/report-template/summary'
import { ReportFinancesDataReplenishmentSummary } from 'app/dataTypes/reports/data/common/financesSummaryReplenishment'

type Props = {
  title: string
  total: ReportFinancesDataReplenishmentSummary['total']
  currency: string
  pending: boolean
}

export const Summary = ({ total, title, currency, pending }: Props) => {
  const { value } = total
  return (
    <SummaryWrap>
      <SummaryItem title={title} value={`${value} ${currency}`} pending={pending} />
    </SummaryWrap>
  )
}
